import { render } from "./MarketplaceConnectDialogContent.vue?vue&type=template&id=4a275ad4&scoped=true"
import script from "./MarketplaceConnectDialogContent.vue?vue&type=script&lang=js"
export * from "./MarketplaceConnectDialogContent.vue?vue&type=script&lang=js"

import "./MarketplaceConnectDialogContent.vue?vue&type=style&index=0&id=4a275ad4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a275ad4"]])

export default __exports__